function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, $hooks, JSON, Object, String, contextPanelTransform, isOpen, searchFilter, sectionsFromInputFn, tooltipData) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['label'] = function({
      includeLeftIcon,
      includeRightIcon
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'select-label-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((leftIcon && includeLeftIcon) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                elref: `leftIcon`,
                icon: leftIcon,
              }),
              "class": Object.assign({}, {
                'select-has-label': $helpers.hasSelectedLabel()
              }, {
                'left-icon': true
              }),
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(($helpers.hasSelectedLabel()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                elref: 'label'
              }),
              "class": {
                'select-label': true
              },
            }, [__vjadeSafeCode($helpers.selectedLabel())]));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((hasButtonSuffixSlot) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: `button-suffix`
              }),
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((rightIcon && includeRightIcon) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                elref: `rightIcon`,
                icon: rightIcon,
              }),
              "class": Object.assign({}, {
                'select-has-label': $helpers.hasSelectedLabel()
              }, {
                'right-icon': true
              }),
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const hasTriggerSlot = $helpers.hasSlot(`trigger`);;
    const hasBodySlot = $helpers.hasSlot(`body`);;
    const hasFooterSlot = $helpers.hasSlot(`footer`);;
    const hasButtonSuffixSlot = $helpers.hasSlot(`button-suffix`);;
    const {
      leftIcon,
      rightIcon
    } = $helpers.getIcon();;
    const THEME = $helpers.THEME;;
    const theme = $attr(`theme`);;
    const tooltip = $attr(`tooltip`);;
    const showHoverContextPanel = contextPanelTransform && !hasTriggerSlot;;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'has-trigger-slot': hasTriggerSlot
        }, {
          'select-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!isOpen && tooltip) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
            "attrs": __vjadeStringifyAttrsIfObj({
              placement: tooltip.placement || `top`,
              'always-show': tooltip['always-show'] || false,
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(tooltip.text);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((!isOpen && showHoverContextPanel && tooltipData) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`tooltip-data`, null)
            },
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `hoverContextPanel`,
              'tooltip-data': JSON.stringify(tooltipData),
              'position-parent-selector': `.select-container`,
              placement: `bottom`,
            }),
            "on": {
              hoverIn: $helpers.handleContextPanelHoverIn,
              hoverOut: $helpers.handleContextPanelHoverOut,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            elref: 'trigger'
          }),
          "on": {
            click: $attr(`disabled`) ? null : () => $component.setDropMenuIsOpen(!isOpen),
            mouseenter: showHoverContextPanel && $helpers.handleTriggerMouseEnter,
            mouseleave: showHoverContextPanel && $helpers.handleTriggerMouseLeave,
          },
          "class": Object.assign({}, {
            'has-trigger-slot': hasTriggerSlot,
          }, {
            'select-trigger': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($helpers.isButtonSelect()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj(Object.assign({
                theme: this.attr(`theme`),
                size: this.attr(`size`),
                disabled: this.attr(`disabled`),
                'not-focusable': true,
                pressed: isOpen,
              }, leftIcon ? {
                icon: leftIcon
              } : {})),
              "class": {
                truncated: !$attr(`no-button-truncate`),
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!$attr(`icon-only`) || $attr(`show-icon-only-down-caret`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['label'].call(this, {
                  includeRightIcon: $helpers.shouldShowRightIcon()
                }));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : (hasTriggerSlot) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: `trigger`
              }),
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['label'].call(this, {
              includeLeftIcon: true
            }));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  putting if block here to conserve dom memory and only load options list until opened */
        __jade_nodes = __jade_nodes.concat((isOpen) ? ((function() {
          var __jade_nodes = [];
          const isSearchable = $helpers.isSearchable();;
          const menuWidth = $helpers.getDropMenuWidth(isSearchable);;
          const menuHeight = $helpers.getDropMenuHeight();;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'select-drop-menu': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'caret-pos': JSON.stringify($attr(`caret-pos`)),
                'open': isOpen,
                'with-caret': Boolean($attr(`caret-pos`)),
                'prevent-close-selectors': [`.select-trigger`],
                'use-fixed-pos': $attr(`use-fixed-dropmenu-pos`),
                'responsive': true,
              }),
              "on": {
                change: $helpers.handleDropMenuChange
              },
              "hook": {
                insert: $helpers.handleDropMenuInsert
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((hasBodySlot) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("slot", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    name: `body`
                  }),
                }));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`header-title`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "style": {
                      'width': `${menuWidth}px`
                    },
                    "class": {
                      'header-title': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(($attr(`back-button`)) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          theme: `tertiary`,
                          icon: `caret-left`,
                          title: `Back (⇦ Left Arrow)`
                        }),
                        "on": {
                          click: $helpers.handleBackClick
                        },
                        "class": {
                          'back-button': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'title-text': true
                      },
                    }, [__vjadeSafeCode($attr(`header-title`))]));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat((isSearchable) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-input", {
                    "key": $attr(`header-title`),
                    "style": {
                      'width': `${menuWidth}px`
                    },
                    "attrs": __vjadeStringifyAttrsIfObj({
                      elref: `searchInput`,
                      icon: `search`,
                      placeholder: $attr(`search-placeholder`),
                      'show-clear': true,
                      tabindex: 0,
                    }),
                    "props": {
                      value: searchFilter
                    },
                    "on": {
                      clear: () => $helpers.handleSearchInput(``),
                      input: ({
                        target
                      }) => $helpers.handleSearchInput(target.value),
                    },
                    "hook": {
                      insert: $helpers.handleSearchInputInsert,
                      destroy: () => $component.focus(),
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                  "key": $attr(`header-title`),
                  "style": {
                    'width': `${menuWidth}px`,
                    'max-height': `${menuHeight}px`,
                  },
                  "attrs": __vjadeStringifyAttrsIfObj({
                    multiple: $attr(`multiple`),
                    'show-select-all': $attr(`show-select-all`),
                    'search-filter': searchFilter,
                    'empty-message': $attr(`empty-message`),
                    'align-all-text': $attr(`align-all-text`),
                  }),
                  "props": {
                    sections: $helpers.getItemsMenuSections(),
                    sectionsFromInputFn,
                    keydownProxyEl: $component,
                    contextPanelTransform: $helpers.itemContextPanelTransform(),
                  },
                  "on": {
                    clickItem: $helpers.handleClickItem,
                    clickActionIcon: $helpers.handleClickActionIcon,
                    focusItem: $helpers.handleFocusItem,
                    selectAll: $helpers.handleSelectAll,
                  },
                }));;
                return __jade_nodes
              }).call(this))); /*  footer slot */
              __jade_nodes = __jade_nodes.concat((hasFooterSlot) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'select-footer': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("slot", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      name: `footer`
                    }),
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "contextPanelTransform" in locals ? locals.contextPanelTransform : typeof contextPanelTransform !== "undefined" ? contextPanelTransform : undefined, "isOpen" in locals ? locals.isOpen : typeof isOpen !== "undefined" ? isOpen : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "sectionsFromInputFn" in locals ? locals.sectionsFromInputFn : typeof sectionsFromInputFn !== "undefined" ? sectionsFromInputFn : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;